import { configureStore } from "@reduxjs/toolkit";
import { dashboardReducer } from "./slices/dashboardSlice";
import { chatReducer } from "./slices/chatSlice";
import { copilotReducer } from "./slices/copilotSlice";
import { fileReducer } from "./slices/fileSlice";
import { uploadFileReducer } from "./slices/uploadFileSlice";
import { listenerMiddleware } from "../middleware/listenerMiddleware";
import { deviceReducer } from "./slices/deviceSlice";
import { metricsReducer } from "./slices/metricsSlice";
import { monitoringDashboardReducer } from "./slices/monitoringDashboardSlice";
import { appAuthReducer } from "./slices/appAuthSlice";
import { templateReducer } from "./slices/templateSlice";
import { recordingUploadReducer } from "./slices/recordingUploadSlice";
import tutorialReducer from "./slices/tutorialSlice";
import { uiReducer } from "./slices/uiSlice";

export const store = configureStore({
  reducer: {
    appAuthReducer,
    dashboardReducer,
    chatReducer,
    fileReducer,
    uploadFileReducer,
    deviceReducer,
    metricsReducer,
    monitoringDashboardReducer,
    templateReducer,
    recordingUploadReducer,
    tutorialReducer,
    copilotReducer,
    uiReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(listenerMiddleware.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
